import moment from 'moment'

export const PRODUCT_LAUNCH_DATE = moment(new Date(1978, 0, 1))
